export enum ProfileStatus {
  Null = 0,
  Published,
  Editing,
  Saved,
}
